<script lang="ts">
    import { Button, Col,Popover } from "sveltestrap";
    import Card from "../UiCommenCard.svelte";
    import {BasicExamples, Clicktotogglepopover, Dismissiblepopover, OnHoverTooltip, PopoverContent, PopoverDetail} from "../../../utils/Constant/Constant";
</script>
<Col sm="12">
    <Card cardHeaderprops="pb-0" headerTitle={BasicExamples} headerContent={PopoverDetail} CardBodyprops="btn-showcase">
      <div slot="contentbody">
        <Button color="primary" id="togglepopover">{Clicktotogglepopover}</Button>
            <Popover placement="right" target="togglepopover" title="Popover title" >And here's some amazing content. It's very engaging. Right? </Popover>
            <Button color="primary" id="Dismissible">{Dismissiblepopover}</Button>
            <Popover trigger="focus" placement="right" target="Dismissible" title="Popover title" >And here's some amazing content. It's very engaging. Right? </Popover>
            <Button color="primary" id="HoverTooltip">{OnHoverTooltip}</Button>
            <Popover trigger="hover" placement="bottom" target="HoverTooltip" title="Popover title" >{PopoverContent}</Popover>
      </div>
    </Card>
</Col>